import { motion } from "framer-motion";
import { toast } from "sonner";
import { LINKS, isConfigured } from "../../config/links";
import { openApp } from "./Navbar";

const storeClick = (url, name) => {
  if (isConfigured(url)) window.open(url, "_blank", "noopener");
  else toast.info(`${name} listing coming soon`, { description: "This badge will link to the store the moment GoDiGo is published." });
};

export const StoreBadges = ({ testPrefix = "cta" }) => (
  <div className="flex flex-wrap items-center gap-4">
    <button
      data-testid={`${testPrefix}-google-play-badge`}
      onClick={() => storeClick(LINKS.playStoreUrl, "Google Play")}
      className="flex items-center gap-3 rounded-xl border border-white/20 bg-black px-5 py-3 text-left text-white transition-transform duration-200 hover:-translate-y-0.5"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M3.6 2.3 13.5 12 3.6 21.7A2 2 0 0 1 3 20.3V3.7c0-.55.23-1.05.6-1.4Z" fill="#34D399" />
        <path d="m13.5 12 3.3-3.2 3.6 2c1.2.68 1.2 1.72 0 2.4l-3.6 2-3.3-3.2Z" fill="#A3E635" />
        <path d="M3.6 2.3c.4-.3.95-.36 1.5-.05l11.7 6.55L13.5 12 3.6 2.3Z" fill="#6EE7B7" />
        <path d="M13.5 12 16.8 15.2 5.1 21.75c-.55.31-1.1.25-1.5-.05L13.5 12Z" fill="#10B981" />
      </svg>
      <span>
        <span className="block text-[10px] uppercase tracking-wide opacity-70">Get it on</span>
        <span className="block font-heading text-sm font-bold">Google Play</span>
      </span>
    </button>
    <button
      data-testid={`${testPrefix}-app-store-badge`}
      onClick={() => storeClick(LINKS.appStoreUrl, "App Store")}
      className="flex items-center gap-3 rounded-xl border border-white/20 bg-black px-5 py-3 text-left text-white transition-transform duration-200 hover:-translate-y-0.5"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
        <path d="M17.05 12.54c-.03-2.9 2.37-4.29 2.48-4.36-1.35-1.98-3.45-2.25-4.2-2.28-1.79-.18-3.49 1.05-4.4 1.05-.9 0-2.3-1.02-3.79-1-1.95.03-3.75 1.13-4.75 2.88-2.03 3.52-.52 8.73 1.46 11.59.97 1.4 2.12 2.97 3.63 2.91 1.46-.06 2.01-.94 3.77-.94s2.26.94 3.8.91c1.57-.03 2.57-1.42 3.53-2.83 1.11-1.62 1.57-3.19 1.6-3.27-.04-.02-3.06-1.18-3.13-4.66ZM14.16 4.06c.8-.98 1.35-2.33 1.2-3.68-1.16.05-2.57.77-3.4 1.75-.75.86-1.4 2.25-1.23 3.57 1.3.1 2.62-.66 3.43-1.64Z" />
      </svg>
      <span>
        <span className="block text-[10px] uppercase tracking-wide opacity-70">Download on the</span>
        <span className="block font-heading text-sm font-bold">App Store</span>
      </span>
    </button>
  </div>
);

export default function DownloadCTA() {
  return (
    <section className="py-20 lg:py-28" data-testid="download-cta-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="grain relative overflow-hidden rounded-[2.5rem] bg-[#1B4D3E] px-8 py-16 text-white sm:px-14 lg:px-20 lg:py-20"
        >
          <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-lime-300/10 blur-3xl" />
          <div className="relative max-w-2xl">
            <p className="overline-label !text-lime-300">Get the app</p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              Put your life on <span className="font-serif-accent italic text-lime-300">autopilot.</span>
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-emerald-100/90">
              Download GoDiGo and let your voice do the organizing. Store listings are coming soon — badges below will go live at launch.
            </p>
            <div className="mt-9">
              <StoreBadges testPrefix="download-cta" />
            </div>
            <button data-testid="download-cta-open-godigo" onClick={openApp} className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-lime-300 underline-offset-4 hover:underline">
              Already have GoDiGo? Open the app →
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
